<script
	lang="ts"
	module
>
	export type AdditionalInfoType = 'Basic Info' | 'Components' | 'Custom Fields' | 'Attachments' | 'Messages'

	//end of context=module
</script>

<script lang="ts">
	import type { Vehicle } from './results.ts'
	import type { SvelteAsr } from 'types/common'
	import type { i18n } from 'types/common'

	import Select from '@isoftdata/svelte-select'
	import Button from '@isoftdata/svelte-button'
	import VehicleInfo from 'components/search/VehicleInfo.svelte'
	import VehicleAttachments from 'components/search/ItemDetailAttachments.svelte'
	import VehicleComponents from './VehicleComponents.svelte'
	import InventoryCustomFields from 'components/search/InventoryCustomFields.svelte'
	import { getContext } from 'svelte'
	// import PartMessages from './PartMessages.svelte'

	interface Props {
		asr: SvelteAsr
		item: Vehicle //required
		additionalInfoType?: AdditionalInfoType
	}

	let { asr, item, additionalInfoType = $bindable('Basic Info') }: Props = $props()

	let vehicleAttachments: VehicleAttachments | undefined = $state()

	const { t: translate } = getContext<i18n>('i18next')

	const additionalInfoTypeList: Array<AdditionalInfoType> = ['Basic Info', 'Components', 'Custom Fields', 'Attachments'] //Skipping 'Messages' for now
</script>

<div class="d-flex justify-content-between align-items-end mb-2">
	<Select
		showEmptyOption={false}
		label={translate('common:vehicleInformation', 'Vehicle Information')}
		bind:value={additionalInfoType}
	>
		{#each additionalInfoTypeList as additionalInfoTypeItem}
			<option value={additionalInfoTypeItem}>{additionalInfoTypeItem}</option>
		{/each}
	</Select>
	<Button
		outline
		size="sm"
		iconClass="pencil"
		class="mb-1 ms-2"
		href={asr.makePath('app.vehicle', { vehicleId: item.id, storeId: item.storeId })}
		>{translate('vehicleSearch.editVehicle', 'Edit Vehicle')}</Button
	>
</div>

<!-- Ensure components get rerendered when the item changes. Fixes an issue with attachments -->
{#key item.id}
	{#if additionalInfoType === 'Basic Info'}
		<VehicleInfo
			showEditButton={false}
			{asr}
			vehicleId={item.id}
			imageClicked={() => (additionalInfoType = 'Attachments')}
		/>
		<!--
		{:else if additionalInfoType === 'Messages'}
			<PartMessages inventoryId={item.id} />
		-->
	{:else if additionalInfoType === 'Custom Fields'}
		<InventoryCustomFields
			vehicle
			inventoryId={item.wholeUnit.id}
		/>
	{:else if additionalInfoType === 'Components'}
		<VehicleComponents
			{asr}
			vehicleId={item.id}
		/>
	{:else if additionalInfoType === 'Attachments'}
		<VehicleAttachments
			attachments={item?.attachments ?? []}
			bind:this={vehicleAttachments}
		/>
	{/if}
{/key}
